import { MODULE_KEYS_MAP } from "@/api/permissions/permissions.types";
import { useBreadcrumb } from "@/hooks/useBreadcrumb";
import { getRouteIcon } from "@/utils/getRouteIconComponent";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/")({
  component: Settings,
});

function Settings() {
  useBreadcrumb([
    {
      title: "Settings",
      href: "/settings",
      icon: getRouteIcon(MODULE_KEYS_MAP.settings),
    },
  ]);
  return <div>Work in progress</div>;
}
